import {
	MDX_ATTRIBUTES_SOURCE,
	readMdxAttributes,
} from "@productlane/lib/src/tiptap/extensions/mintlify/icon-html"
import { tooltipHtml } from "@productlane/lib/src/tiptap/extensions/mintlify/tooltip-html"

const TOOLTIP = new RegExp(
	`<Tooltip${MDX_ATTRIBUTES_SOURCE}>([\\s\\S]*?)</Tooltip>`,
	"g",
)

/** marked leaves an inline `<Tooltip>` as raw HTML; this turns it into ours. */
export function renderTooltipInline(html: string): string {
	return html.replace(TOOLTIP, (_whole, attributes: string, inner: string) =>
		tooltipHtml(readMdxAttributes(attributes ?? ""), inner),
	)
}
